import { render, staticRenderFns } from "./PromotionLogListTable.vue?vue&type=template&id=799f7f72"
import script from "./PromotionLogListTable.vue?vue&type=script&lang=js"
export * from "./PromotionLogListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports